import { atom } from "nanostores";

/** Where the player is (spec 2o §4.1): the lobby, the room, or fading between them. */
export type RoomPhase = "lobby" | "entering" | "room" | "leaving";
export const $roomPhase = atom<RoomPhase>("lobby");
/** The menu increments this to go to the room or back to the lobby, as R does. */
export const $roomRequest = atom(0);
export const inRoom = (): boolean => $roomPhase.get() !== "lobby";

/** The room's touch button word for what the crosshair is on, or null (spec 2p §2.2). */
export const $roomAction = atom<string | null>(null);
